import { FormatIcu } from '@tolgee/format-icu';
//
import { BackendFetch, DevTools, Tolgee } from '@tolgee/react';
//
import { Session } from '../state/session';
import { defaultLang } from './config-lang';

const lng = Session.getItem('defaultLang') || defaultLang.value;

export const i18n = Tolgee()
  .use(DevTools())
  .use(FormatIcu())
  .use(BackendFetch({ prefix: import.meta.env.VITE_APP_TOLGEE_CDN }))
  .init({
    availableLanguages: ['en', 'pt-BR', 'es-ES'],
    apiUrl: import.meta.env.VITE_APP_TOLGEE_API_URL,
    apiKey: import.meta.env.VITE_APP_TOLGEE_API_KEY,
    projectId: import.meta.env.VITE_APP_TOLGEE_PROJECT_ID,
    fallbackLanguage: defaultLang.value,
    defaultLanguage: lng,
  });

// i18n
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     resources: {
//       en: { translations: enLocales },
//       ptBR: { translations: ptBRLocales },
//     },
//     lng,
//     fallbackLng: defaultLang.value,
//     debug: false,
//     ns: ['translations'],
//     defaultNS: 'translations',
//     interpolation: {
//       escapeValue: false,
//     },
//   });
